import React from "react";

import { ENGINE_COMPONENT_TYPES } from "../../constants";
import Accordion from "./Accordion";
import AspectRatio from "./AspectRatio";

const ViewPort = ({ updateAspectRatio, aspectRatio, componentConfig }) => {
  const panelList = componentConfig?.components.map((component) => {
    let renderComp = null;
    switch (component.type) {
      case ENGINE_COMPONENT_TYPES.ASPECT_RATIO_COMPONENT: {
        renderComp = (
          <AspectRatio
            updateAspectRatio={updateAspectRatio}
            aspectRatio={aspectRatio}
            aspectRatioList={component.getAspectRatioList()}
          />
        );
        break;
      }
      default:
        break;
    }
    return {
      header: component.title,
      headerClass: "light-accordion-header",
      component: renderComp,
    };
  });
  return (
    <div className="viewPortContainer">
      <Accordion className="viewport-accordion" panelList={panelList} />
    </div>
  );
};

export default ViewPort;
